/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import { uniqBy } from 'lodash'
import NotFoundMediaImage from '~/assets/projects/not_found_media.png'
import { NotFoundError } from '~/errors/NotFoundError'
import ProjectAsset from '~/models/ProjectData/ProjectAsset'
import ProjectTextAsset from '~/models/ProjectData/ProjectTextAsset'
import ProjectTransitionAsset from '~/models/ProjectData/ProjectTransitionAsset'
import * as API from '~/ServerAPI'
import { fetchAudioFile } from '~/services/AudioLibraryService'
import { SOURCE_FILE_TYPES } from '~/enums'
import ProjectVideoAsset from '~/models/ProjectData/ProjectVideoAsset'

const handleDeletedMedia = (asset, error) => {
  asset.thumbnail = NotFoundMediaImage
  asset.mediaDeleted = true
  asset.errorMessage = error.message
  asset.errorType = error.type
  asset.sourceFileType = SOURCE_FILE_TYPES.MEDIA
}

export const prepareProjectAssets = async assets => {
  const MAX_REQUESTS = 5
  const projectAssets = [ ...assets ]
  const sentIds = []
  while (projectAssets.length) {
    const requests = []
    const dispatchGroup = uniqBy(projectAssets.splice(0, MAX_REQUESTS), a => a.fileId)
      .filter(asset => !sentIds.includes(asset.fileId))
    for (let i = 0; i < dispatchGroup.length; i++) {
      const asset = dispatchGroup[i]
      const { fileId } = asset
      if (!(asset instanceof ProjectTextAsset || asset instanceof ProjectTransitionAsset)
        && asset instanceof ProjectAsset) {
        if (fileId) {
          const { type } = asset
          const getMedia = asset.sourceFileType === SOURCE_FILE_TYPES.AUDIO
            ? fetchAudioFile
            : API.getMediaFile
          requests.push(
            getMedia(fileId, type, asset.sourceFileType)
              .then(({ data }) => {
                const { thumbnail, previewUrl } = data ?? {}
                for (const pAsset of assets) {
                  if (pAsset.fileId === fileId) {
                    const { mediaStart } = pAsset
                    if (!(pAsset instanceof ProjectVideoAsset) || !mediaStart) {
                      pAsset.thumbnail = thumbnail // Isn't saved in project json
                    }
                    if (previewUrl) {
                      pAsset.url = previewUrl
                    } else {
                      handleDeletedMedia(pAsset, 'No video url')
                    }
                  }
                }
              })
              .catch(e => {
                for (const pAsset of assets) {
                  if (pAsset.fileId === asset.fileId) {
                    if (e instanceof NotFoundError) {
                      handleDeletedMedia(pAsset, e)
                    } else {
                      console.error(pAsset, e)
                    }
                  }
                }
              })
          )
          sentIds.push(fileId)
        } else {
          for (const pAsset of assets) {
            if (pAsset.fileId === asset.fileId) {
              handleDeletedMedia(pAsset, 'No file')
            }
          }
        }
      }
    }
    // eslint-disable-next-line
    await Promise.all(requests)
  }
}

export const prepareProjectAsset = async asset => {
  const { fileId } = asset

  if (!(asset instanceof ProjectTextAsset || asset instanceof ProjectTransitionAsset)
    && asset instanceof ProjectAsset) {
    if (fileId) {
      try {
        const { type } = asset
        const getMedia = asset.sourceFileType === SOURCE_FILE_TYPES.AUDIO
          ? fetchAudioFile
          : API.getMediaFile
        const { thumbnail, previewUrl } = (await getMedia(
          fileId, type, asset.sourceFileType
        )).data
        const { mediaStart } = asset
        if (!(asset instanceof ProjectVideoAsset) || !mediaStart) {
          // eslint-disable-next-line no-param-reassign
          asset.thumbnail = thumbnail // Isn't saved in project json
        }
        if (previewUrl) {
          asset.url = previewUrl
        } else {
          handleDeletedMedia(asset, 'No video url')
        }
      } catch (e) {
        if (e instanceof NotFoundError) {
          handleDeletedMedia(asset, e)
        } else {
          console.error(e)
        }
      }
    } else {
      handleDeletedMedia(asset, 'No file')
    }
  }
  return asset
}
